import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col } from "react-bootstrap";
import "./Careers.scss";

import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import GetURL from '@Components/common/site/get-url';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import {ImageModule} from "@Components/common/Image_Module";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1.5,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 2,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const Careers = (props) => {
    const data = useStaticQuery(graphql`
    query{
      glstrapi {
        careers(sort:"Date:DESC", publicationState: LIVE, where: {Publish: true}) {
            id
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            Job_Title
            URL
            Tail_Image {
                alternativeText
                url
            }
        }
      }
    }
    `);

    const [jobs, setJobs] = useState(data.glstrapi?.careers)

    return (jobs.length > 0 ?
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <React.Fragment>
                        <section className="careers-list">
                            <Container>
                                <Row>
                                    <Col lg={12}>
                                        <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                            <motion.div variants={titleVariants}>
                                                <h2>{props.Title}</h2>
                                                <div className="sub-child-desc">
                                                    <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                </div>
                                            </motion.div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                                <Row>
                                    {jobs.map((item, index) => {
                                        let processedImages = JSON.stringify({});
                                        if (item?.imagetransforms?.Image_Transforms) {
                                            processedImages = item.imagetransforms.Image_Transforms;
                                        }
                                        return (
                                            <MotionColumn md={6} xl={3} className="card-container-box" variants={items}>
                                                <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                    <div className="careers-card">

                                                        {item.Tail_Image &&
                                                            <div className="card-img-box">
                                                                <Link class="link-btn" to={item.URL}></Link>
                                                                {/* <picture>
                                        <source media="(min-width:992px)" srcSet={item.Tail_Image.url} />
                                        <source media="(min-width:768px)" srcSet={item.Tail_Image.url} />
                                        <img src={item.Tail_Image.url} alt={item.Tail_Image.alternativeText} />
                                    </picture> */}
                                                                <ImageModule ImageSrc={item?.Tail_Image} attr={{ alt: item.Job_Title }} ggfx_results={item.ggfx_results} imagename="career.Image.tail" strapi_id={item.id} />

                                                                {/* <ImageTransform imagesources={item?.Tail_Image?.url} renderer="srcSet" imagename='career.Image.tail'
                                                                    attr={{ alt: item.Tail_Image?.alternativeText, className: '' }}
                                                                    imagetransformresult={processedImages} id={item.id} >

                                                                </ImageTransform> */}
                                                            </div>
                                                        }
                                                        <div className="img-card-title">
                                                            <ul>
                                                                <li><Link to={item.URL}> {item.Job_Title} </Link></li>
                                                            </ul>
                                                        </div>
                                                        <div className="btm-border-card"></div>
                                                    </div>
                                                </ScrollAnimation>
                                            </MotionColumn>
                                        )
                                    })}
                                </Row>
                            </Container>
                        </section>
                    </React.Fragment>
                </motion.section>
            )}
        </InView>
    : null)
}

export default Careers;
